<template>
  <div class="subsc-cancel">
    <ul class="note-list">
      <li class="note-list__item">解約する{{ userProfile.subscription.next_payment_due | convertKanjiYMD}}以降サービスが利用できなくなります。</li>
      <li class="note-list__item">サブスクリプションはいつでも再開できます。お気に入りやアカウント情報は10ヶ月間保存されます。</li>
    </ul>
    <form-area
      :action="action"
      :method="method"
      :token="token"
    >
      <BaseCheckbox
        name="mail_magazine"
        :value="mailMagazine"
        label="新着メニューや割引情報などお得な情報を希望します。"
        :isChecked="mailMagazine === 1"
        :validation="{}"
        @change="changeChecked"
      />
      <submit-button type="submit" text="解約手続きをする" />
    </form-area>
  </div>
</template>

<script>
import SubmitButton from '../partials/SubmitButton'
import BaseCheckbox from '../common/BaseCheckbox'

export default {
  name: "SubscCancel",
  components: {
    BaseCheckbox,
    SubmitButton
  },
  props: {
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'POST'
    },
    token: {
      type: String,
      default: ''
    },
    userProfile: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // メルマガ
      mailMagazine: this.userProfile.mail_magazine || 0,
    }
  },
  methods: {
    changeChecked (target) {
      this.mailMagazine = target.checked ? 1 : 0
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.subsc-cancel {
  padding: 32px 4px 30px;
  color: $col_base_black;
  line-height: 1.57;
}
.note-list {
  padding: 0 0 0 16px;
  margin: 0 0 32px;
  &__item {
    list-style: disc outside;
    margin: 0 0 6px;
    font-size: 13px;
    text-align: justify;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.submit-button {
  margin-top: 40px;
}
</style>

<style lang="scss">
.subsc-cancel .baseCheckBox__label {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SubscCancel.vue